/*
 * @Author: Mike Cottingham 
 * @Date: 2018-04-24 19:22:43 
 * @Last Modified by: Mike Cottingham
 * @Last Modified time: 2018-04-25 22:23:31
 */


export const moduleName = "invoice"